module.exports = __webpack_public_path__ + "img/web-design-agency-doncaster.2461e6fe.png";